import { lazyLoad } from 'utils/loadable';

export const PreferencesPage = lazyLoad(
  () => import('./PreferencesPage'),
  module => module.PreferencesPage,
);
